import { useSuspenseQuery } from '@tanstack/react-query';
import { setMinimalPromiseTime } from 'src/common/utils/setMinimalPromiseTime';
import { UsageTypeValue } from 'src/common/components/UsageTypeSwitch/UsageTypeSwitch';
import { ChartTypeValue } from 'src/common/components/ChartTypeToggle/ChartTypeToggle';
import { mapUsageDTOtoAreaChartData } from 'src/common/utils/mapUsageDTOtoAreaChartData';
import { productSummaryGraphsQueries } from '../queries/productSummaryGraphsQueries';
import { getProductSummaryCumulativeUsage } from '../api/productSummaryGraphsApi';
import { useTranslation } from 'react-i18next';

type UseProductsSummaryCumulativeUsageDataProps = {
  productCode: string;
  chartType: ChartTypeValue;
  usageType: UsageTypeValue;
};

type MappedUsageData = ReturnType<typeof mapUsageDTOtoAreaChartData>;

export const useProductsSummaryUsageData = ({
  productCode,
  chartType,
  usageType,
}: UseProductsSummaryCumulativeUsageDataProps) => {
  const { t } = useTranslation();
  const { data } = useSuspenseQuery<
    Awaited<ReturnType<typeof getProductSummaryCumulativeUsage>>,
    Error,
    MappedUsageData
  >({
    queryKey: productSummaryGraphsQueries.cumulativeUsage({
      productCode,
      chartType,
      usageType,
    }),
    queryFn: () =>
      setMinimalPromiseTime(
        getProductSummaryCumulativeUsage({ productCode, chartType, usageType }),
      ),
    select: (chartData) => mapUsageDTOtoAreaChartData(chartData, usageType, t),
  });

  return data;
};
